<template>
    <div>
        <div class="card">
            <b-navbar toggleable="lg" type="transparent" class="rounded">
                <b-navbar-brand href="#" class="text-primary d-lg-none">{{t('directCharge')}}</b-navbar-brand>


                <b-navbar-toggle class="border-0" target="nav-collapse">
                     <template #default>
                        <div class="text-primary">
                            <feather-icon size="25" icon="ListIcon"></feather-icon>
                        </div>
                    </template>
                </b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <div class="nav-horizontal">
                        <ul role="tablist" class="nav nav-tabs nav-right d-block d-md-flex">
                            <li role="tab-item" class="nav-item text-left">
                                <router-link to="/transactions/requests/list" :class="`nav-link ${active == 1? 'active':''}`" role="tab" aria-selected="true" aria-setsize="5" aria-posinset="1">{{t('all')}}</router-link>
                            </li>
                            <li role="tab-item" class="nav-item text-left">
                                <router-link to="/transactions/requests/create" :class="`nav-link ${active == 2? 'active':''}`" role="tab" aria-selected="true" aria-setsize="5" aria-posinset="1">{{t('create')}}</router-link>
                            </li>
                            <li role="tab-item" class="nav-item text-left">
                                <router-link to="/transactions/requests/list-api" :class="`nav-link ${active == 3? 'active':''}`" role="tab" aria-selected="true" aria-setsize="5" aria-posinset="1">{{t('apiOnly')}}</router-link>
                            </li>
                            <li role="tab-item" class="nav-item text-left">
                                <router-link to="/transactions/requests/list-manual-requests" :class="`nav-link ${active == 4? 'active':''}`" role="tab" aria-selected="true" aria-setsize="5" aria-posinset="1">{{t('manualRequests')}}</router-link>
                            </li>
                            <li role="tab-item" class="nav-item text-left">
                                <router-link to="/transactions/requests/list-split-payments" :class="`nav-link ${active == 5? 'active':''}`" role="tab" aria-selected="true" aria-setsize="5" aria-posinset="1">{{t('splitPayments')}}</router-link>
                            </li>
                        </ul>
                    </div>
                </b-collapse>
            </b-navbar>
        </div>
    </div>
</template>
<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import router from '@/router'

export default {
    name: "InvoiceTabs",
    props:{
        active: {
            type: Number,
            default: 1
        }
    },
    methods: {

    },
    setup(props) {
    const { t } = useI18nUtils()

    return {
      // i18n
      t,
     }
  }
}
</script>

<style>
    .navbar-toggler-icon {
        height: 1em;
        width: 1em;
    }
</style>